import { useEffect, useCallback, useState, useMemo, useRef } from 'react'

import _ from 'lodash'

import { Settings } from 'helpers/settings-enum'
import { settingsMenuSelector } from 'slices/ui'


import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { useSelector } from 'react-redux'
import { RootState } from 'slices'
import { useAppDispatch } from 'store'

import client from 'api'

import { zeroPad } from 'helpers'


import { BaseLookup } from '../base-lookup'
import { useIxLookupContext } from 'contexts/lookup-context'
import { ixStringToInt } from 'helpers/string-utils'
import { useLookupFetch, LookupFetchConfig, useFiltersList } from 'hooks'
import { fetchLookupData, lookupDataSelector } from 'slices/lookup-data-slice'
import {
    useContextFilterCallback,
    ShouldUpdateArray,
    useContextSelfCallback,
    useSelectionChangedCallback,
    useInputChangedCallback,
} from 'hooks'


const _valueExpr = 'NO'

const inputRe = [
/^((?<OBJNR>\d+)\+)?(?<NO>\w+)$/,
]

const inputFormat = (x: any) => {
    return x ? `${x.OBJNR}+${x.NO}` : ''
}

const fetchConfig: LookupFetchConfig = {
    url: '/api/ixweb/per/',
    fields: 'HDR_ID,HDR_H1_USERID,HDR_H1_TIMESTAMP,OBJNR,NO,ID,HDR_H2_USERID,HDR_H2_TIMESTAMP,HDR_VERSION,MASK_1,MASK_2,MASK_3,MASK_4,MASK_5,MASK_6,MASK_7,MASK_8,MASK_9,INFO_1,INFO_2,ADAM,LOCADAM,MASK2_1,MASK2_2,NOTE_1,NOTE_2,NOTE_3,WNO,GUTSCHR,ZUSTIMM,UAW,MSP,BANK_OWN,BANK_BNK,BANK_BLZ,BANK_KTO,BANK_EZ,CON_BEGIN,CON_END,CON_NOTICE,CON_PKIND,CON_PMWST,CON_MAHN,UL_FLAG,UL_UID,UL_STAMP,MGV,PEF_PAD,PEF_UMI,PEF_IMI,PEF_WBG,PEF_STM,PI_INO,PI_IBEG,PI_IART,PI_IWEIT,PI_IAUTO,PI_IZEIT1,PI_IZEIT2,PI_ILZB,PI_ILAST,PI_IBEM,PI_IKTO,HKD_NO,HKD_KND,HKD_ORD,WZWG_NO,RFRM_NO,BONI_NO,VH_DTM,VH_MON,KKLLIST,ALTBANK_OWN,ALTBANK_BNK,ALTBANK_BLZ,ALTBANK_KTO,ALTBANK_EZ,ZIELBANK_OWN,ZIELBANK_BNK,ZIELBANK_BLZ,ZIELBANK_KTO,ZIELBANK_EZ,REMIND_TABID_1,REMIND_TABID_2,REMIND_TABID_3,REMIND_TABID_4,REMIND_TABID_5,REMIND_TABID_6,REMIND_TABID_7,REMIND_TABID_8,REMIND_TABID_9,REMIND_TABID_10,REMIND_MINDMAHN_1,REMIND_MINDMAHN_2,REMIND_MINDMAHN_3,REMIND_MINDMAHN_4,REMIND_MINDMAHN_5,REMIND_MINDMAHN_6,REMIND_MINDMAHN_7,REMIND_MINDMAHN_8,REMIND_MINDMAHN_9,REMIND_MINDMAHN_10,REMIND_PRO_MON_1,REMIND_PRO_MON_2,REMIND_PRO_MON_3,REMIND_PRO_MON_4,REMIND_PRO_MON_5,REMIND_PRO_MON_6,REMIND_PRO_MON_7,REMIND_PRO_MON_8,REMIND_PRO_MON_9,REMIND_PRO_MON_10,REMIND_REMIND_DATE_1,REMIND_REMIND_DATE_2,REMIND_REMIND_DATE_3,REMIND_REMIND_DATE_4,REMIND_REMIND_DATE_5,REMIND_REMIND_DATE_6,REMIND_REMIND_DATE_7,REMIND_REMIND_DATE_8,REMIND_REMIND_DATE_9,REMIND_REMIND_DATE_10,REMIND_CHECK_DATE,REMIND_BUNO,REMIND_GEBUEHR_1,REMIND_GEBUEHR_2,REMIND_GEBUEHR_3,REMIND_GEBUEHR_4,REMIND_GEBUEHR_5,REMIND_GEBUEHR_6,REMIND_GEBUEHR_7,REMIND_GEBUEHR_8,REMIND_GEBUEHR_9,REMIND_GEBUEHR_10,REMIND_MINDWCODE_1,REMIND_MINDWCODE_2,REMIND_MINDWCODE_3,REMIND_MINDWCODE_4,REMIND_MINDWCODE_5,REMIND_MINDWCODE_6,REMIND_MINDWCODE_7,REMIND_MINDWCODE_8,REMIND_MINDWCODE_9,REMIND_MINDWCODE_10,INTERMODELL,LKZ,ALTLKZ,ZIELLKZ,STARTEZ,ENDEEZ,WAEHRUNGSCODE,OLDWAEHRUNGSCODE,WRNGUMSDAT,MSPZUSCHLAG,LBUCHTYP,VARIANTE,TEXTGUTSCHRIFT,TEXTLASTSCHRIFT,KEINEMIETRECHNUNG,AUSZAHLUNGSSPERRE,IBAN,SWIFT,LANDLKZID,ALTLANDLKZID,EZTYP,PERZVGRID,SEVBANK,SEVALTBANK,SEVOBJNR,SEVPERNR,BANK_IBAN,BANK_BIC,ALTBANK_IBAN,ALTBANK_BIC,ZIELBANK_IBAN,ZIELBANK_BIC,BEIRAT,OBJID,ADMID,OLDFLG,BANK_OWN_KDNR,ALTBANK_OWN_KDNR,ZIELBANK_OWN_KDNR,SEVKAPANLID,KURZNOTIZ,ABRECHNENKEINLEV,MAHNNOTIZ,EWBREGEL,PARTNERROLEID,PARTNERROLE2ID,MAHNAUSBISDAT,DSGVOEINWILLIGUNG,DSGVOINFOTEXT,DAUERMIETRECHNUNG,RNGEMFID,KAPANLBNKID,GLAEUBIGERID,ERECHNUNGTYP,INFO,ANREDE,NAME1,NAME2,STRASSENR,PLZORT,TELEFON,MOBIL,FAX,EMAIL',
    allowedFilters: ['objnr', 'no'],
}

const castToType = (val: any) => {
    return val
}

export const IxTenantLookupFieldsConf = {
    'HDR_ID': { type: 'number' },
    'HDR_H1_USERID': { type: 'number' },
    'HDR_H1_TIMESTAMP': { type: 'datetime' },
    'OBJNR': { type: 'number' },
    'NO': { type: 'string' },
    'ID': { type: 'string' },
    'HDR_H2_USERID': { type: 'number' },
    'HDR_H2_TIMESTAMP': { type: 'date' },
    'HDR_VERSION': { type: 'number' },
    'MASK_1': { type: 'string' },
    'MASK_2': { type: 'string' },
    'MASK_3': { type: 'string' },
    'MASK_4': { type: 'string' },
    'MASK_5': { type: 'string' },
    'MASK_6': { type: 'string' },
    'MASK_7': { type: 'string' },
    'MASK_8': { type: 'string' },
    'MASK_9': { type: 'string' },
    'INFO_1': { type: 'string' },
    'INFO_2': { type: 'string' },
    'ADAM': { type: 'string' },
    'LOCADAM': { type: 'string' },
    'MASK2_1': { type: 'string' },
    'MASK2_2': { type: 'string' },
    'NOTE_1': { type: 'string' },
    'NOTE_2': { type: 'string' },
    'NOTE_3': { type: 'string' },
    'WNO': { type: 'string' },
    'GUTSCHR': { type: 'string' },
    'ZUSTIMM': { type: 'string' },
    'UAW': { type: 'string' },
    'MSP': { type: 'string' },
    'BANK_OWN': { type: 'string' },
    'BANK_BNK': { type: 'string' },
    'BANK_BLZ': { type: 'string' },
    'BANK_KTO': { type: 'string' },
    'BANK_EZ': { type: 'number' },
    'CON_BEGIN': { type: 'string' },
    'CON_END': { type: 'string' },
    'CON_NOTICE': { type: 'string' },
    'CON_PKIND': { type: 'number' },
    'CON_PMWST': { type: 'number' },
    'CON_MAHN': { type: 'number' },
    'UL_FLAG': { type: 'number' },
    'UL_UID': { type: 'raw' },
    'UL_STAMP': { type: 'number' },
    'MGV': { type: 'string' },
    'PEF_PAD': { type: 'string' },
    'PEF_UMI': { type: 'string' },
    'PEF_IMI': { type: 'string' },
    'PEF_WBG': { type: 'string' },
    'PEF_STM': { type: 'string' },
    'PI_INO': { type: 'string' },
    'PI_IBEG': { type: 'string' },
    'PI_IART': { type: 'string' },
    'PI_IWEIT': { type: 'string' },
    'PI_IAUTO': { type: 'string' },
    'PI_IZEIT1': { type: 'string' },
    'PI_IZEIT2': { type: 'string' },
    'PI_ILZB': { type: 'string' },
    'PI_ILAST': { type: 'string' },
    'PI_IBEM': { type: 'string' },
    'PI_IKTO': { type: 'string' },
    'HKD_NO': { type: 'number' },
    'HKD_KND': { type: 'string' },
    'HKD_ORD': { type: 'string' },
    'WZWG_NO': { type: 'string' },
    'RFRM_NO': { type: 'string' },
    'BONI_NO': { type: 'string' },
    'VH_DTM': { type: 'number' },
    'VH_MON': { type: 'number' },
    'KKLLIST': { type: 'string' },
    'ALTBANK_OWN': { type: 'string' },
    'ALTBANK_BNK': { type: 'string' },
    'ALTBANK_BLZ': { type: 'string' },
    'ALTBANK_KTO': { type: 'string' },
    'ALTBANK_EZ': { type: 'number' },
    'ZIELBANK_OWN': { type: 'string' },
    'ZIELBANK_BNK': { type: 'string' },
    'ZIELBANK_BLZ': { type: 'string' },
    'ZIELBANK_KTO': { type: 'string' },
    'ZIELBANK_EZ': { type: 'number' },
    'REMIND_TABID_1': { type: 'number' },
    'REMIND_TABID_2': { type: 'number' },
    'REMIND_TABID_3': { type: 'number' },
    'REMIND_TABID_4': { type: 'number' },
    'REMIND_TABID_5': { type: 'number' },
    'REMIND_TABID_6': { type: 'number' },
    'REMIND_TABID_7': { type: 'number' },
    'REMIND_TABID_8': { type: 'number' },
    'REMIND_TABID_9': { type: 'number' },
    'REMIND_TABID_10': { type: 'number' },
    'REMIND_MINDMAHN_1': { type: 'number.2' },
    'REMIND_MINDMAHN_2': { type: 'number.2' },
    'REMIND_MINDMAHN_3': { type: 'number.2' },
    'REMIND_MINDMAHN_4': { type: 'number.2' },
    'REMIND_MINDMAHN_5': { type: 'number.2' },
    'REMIND_MINDMAHN_6': { type: 'number.2' },
    'REMIND_MINDMAHN_7': { type: 'number.2' },
    'REMIND_MINDMAHN_8': { type: 'number.2' },
    'REMIND_MINDMAHN_9': { type: 'number.2' },
    'REMIND_MINDMAHN_10': { type: 'number.2' },
    'REMIND_PRO_MON_1': { type: 'string' },
    'REMIND_PRO_MON_2': { type: 'string' },
    'REMIND_PRO_MON_3': { type: 'string' },
    'REMIND_PRO_MON_4': { type: 'string' },
    'REMIND_PRO_MON_5': { type: 'string' },
    'REMIND_PRO_MON_6': { type: 'string' },
    'REMIND_PRO_MON_7': { type: 'string' },
    'REMIND_PRO_MON_8': { type: 'string' },
    'REMIND_PRO_MON_9': { type: 'string' },
    'REMIND_PRO_MON_10': { type: 'string' },
    'REMIND_REMIND_DATE_1': { type: 'number' },
    'REMIND_REMIND_DATE_2': { type: 'number' },
    'REMIND_REMIND_DATE_3': { type: 'number' },
    'REMIND_REMIND_DATE_4': { type: 'number' },
    'REMIND_REMIND_DATE_5': { type: 'number' },
    'REMIND_REMIND_DATE_6': { type: 'number' },
    'REMIND_REMIND_DATE_7': { type: 'number' },
    'REMIND_REMIND_DATE_8': { type: 'number' },
    'REMIND_REMIND_DATE_9': { type: 'number' },
    'REMIND_REMIND_DATE_10': { type: 'number' },
    'REMIND_CHECK_DATE': { type: 'number' },
    'REMIND_BUNO': { type: 'number' },
    'REMIND_GEBUEHR_1': { type: 'string' },
    'REMIND_GEBUEHR_2': { type: 'string' },
    'REMIND_GEBUEHR_3': { type: 'string' },
    'REMIND_GEBUEHR_4': { type: 'string' },
    'REMIND_GEBUEHR_5': { type: 'string' },
    'REMIND_GEBUEHR_6': { type: 'string' },
    'REMIND_GEBUEHR_7': { type: 'string' },
    'REMIND_GEBUEHR_8': { type: 'string' },
    'REMIND_GEBUEHR_9': { type: 'string' },
    'REMIND_GEBUEHR_10': { type: 'string' },
    'REMIND_MINDWCODE_1': { type: 'number' },
    'REMIND_MINDWCODE_2': { type: 'number' },
    'REMIND_MINDWCODE_3': { type: 'number' },
    'REMIND_MINDWCODE_4': { type: 'number' },
    'REMIND_MINDWCODE_5': { type: 'number' },
    'REMIND_MINDWCODE_6': { type: 'number' },
    'REMIND_MINDWCODE_7': { type: 'number' },
    'REMIND_MINDWCODE_8': { type: 'number' },
    'REMIND_MINDWCODE_9': { type: 'number' },
    'REMIND_MINDWCODE_10': { type: 'number' },
    'INTERMODELL': { type: 'number' },
    'LKZ': { type: 'string' },
    'ALTLKZ': { type: 'string' },
    'ZIELLKZ': { type: 'string' },
    'STARTEZ': { type: 'string' },
    'ENDEEZ': { type: 'string' },
    'WAEHRUNGSCODE': { type: 'number' },
    'OLDWAEHRUNGSCODE': { type: 'number' },
    'WRNGUMSDAT': { type: 'number' },
    'MSPZUSCHLAG': { type: 'number' },
    'LBUCHTYP': { type: 'number' },
    'VARIANTE': { type: 'number' },
    'TEXTGUTSCHRIFT': { type: 'string' },
    'TEXTLASTSCHRIFT': { type: 'string' },
    'KEINEMIETRECHNUNG': { type: 'string' },
    'AUSZAHLUNGSSPERRE': { type: 'string' },
    'IBAN': { type: 'string' },
    'SWIFT': { type: 'string' },
    'LANDLKZID': { type: 'number' },
    'ALTLANDLKZID': { type: 'number' },
    'EZTYP': { type: 'number' },
    'PERZVGRID': { type: 'number' },
    'SEVBANK': { type: 'number' },
    'SEVALTBANK': { type: 'number' },
    'SEVOBJNR': { type: 'number' },
    'SEVPERNR': { type: 'string' },
    'BANK_IBAN': { type: 'string' },
    'BANK_BIC': { type: 'string' },
    'ALTBANK_IBAN': { type: 'string' },
    'ALTBANK_BIC': { type: 'string' },
    'ZIELBANK_IBAN': { type: 'string' },
    'ZIELBANK_BIC': { type: 'string' },
    'BEIRAT': { type: 'number' },
    'OBJID': { type: 'number' },
    'ADMID': { type: 'number' },
    'OLDFLG': { type: 'number' },
    'BANK_OWN_KDNR': { type: 'string' },
    'ALTBANK_OWN_KDNR': { type: 'string' },
    'ZIELBANK_OWN_KDNR': { type: 'string' },
    'SEVKAPANLID': { type: 'number' },
    'KURZNOTIZ': { type: 'string' },
    'ABRECHNENKEINLEV': { type: 'number' },
    'MAHNNOTIZ': { type: 'string' },
    'EWBREGEL': { type: 'number' },
    'PARTNERROLEID': { type: 'number' },
    'PARTNERROLE2ID': { type: 'number' },
    'MAHNAUSBISDAT': { type: 'date' },
    'DSGVOEINWILLIGUNG': { type: 'number' },
    'DSGVOINFOTEXT': { type: 'string' },
    'DAUERMIETRECHNUNG': { type: 'number' },
    'RNGEMFID': { type: 'number' },
    'KAPANLBNKID': { type: 'number' },
    'GLAEUBIGERID': { type: 'string' },
    'ERECHNUNGTYP': { type: 'number' },
    'INFO': { type: 'string' },
    'ANREDE': { type: 'string' },
    'NAME1': { type: 'string' },
    'NAME2': { type: 'string' },
    'STRASSENR': { type: 'string' },
    'PLZORT': { type: 'string' },
    'TELEFON': { type: 'string' },
    'MOBIL': { type: 'string' },
    'FAX': { type: 'string' },
    'EMAIL': { type: 'string' },
}

export const useIxTenantLookupData = (
    active=true,
    valueExpr: string = _valueExpr,
    _?: any,
) => {
    const dispatch = useAppDispatch()
    const params = useMemo<any>(() => {
        let params = {}
        return params
    }, [])
    const { data } = useSelector((state: RootState) => lookupDataSelector(
        state,
        'IxTenantLookup',
        params
    ))
    const [lookupMap, setLookupMap] = useState<any>(null)
    const { paddings } = useSelector((state: RootState) => state.ui)

    const {value: number} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupNumberFormat))
    const {value: separator} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupSeparatorFormat))
    const {value: info} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupInfoFormat))

    const loadData = useCallback((force=false) => {
        dispatch(fetchLookupData({ lookupName: 'IxTenantLookup', url: fetchConfig.url, params, force }))
    }, [dispatch, params])

    useEffect(() => {
        loadData()
    }, [loadData])

    const format = useCallback((x: any) => {
        return `${number.prefix}${zeroPad(x.OBJNR, paddings['OBJNR'])}+${x.NO !== null && x.NO !== undefined ? x.NO : ''}${number.suffix}${separator.value}${info.prefix} ${x.ID !== null && x.ID !== undefined ? x.ID : ''}${info.suffix}`
    }, [number, paddings, separator, info])

    useEffect(() => {
        if (data) {
            const typesMap = data.map((t: any) => ({
                id: t[valueExpr],
                value: format(t),
                objnr: t['OBJNR'],
            }))
            setLookupMap(typesMap)
        }
    }, [data, format, valueExpr])

    const getFormat = useCallback((no: any, { objnr}: any) => {
        if (lookupMap) {
            const item = lookupMap.find((x: any) => {
                return x.id == no  // eslint-disable-line eqeqeq
                    && x.objnr == objnr  // eslint-disable-line eqeqeq
            })
            return item ? item.value : ''
        }
        return ''
    }, [lookupMap])

    const getLookupValue = useCallback((val: any, extraParams?: any) => {
        const { objnr} = extraParams || {}
        if (data) {
            const item = data.find((x: any) => {
                if (valueExpr === 'HDR_ID') {
                    return x[valueExpr] == val  // eslint-disable-line eqeqeq
                } else {
                    return x[valueExpr] === val  // eslint-disable-line eqeqeq
                        && x.objnr == objnr  // eslint-disable-line eqeqeq
                }
            })

            return item
        }
        return undefined
    }, [data, valueExpr])

    return {
        data,
        format,
        getFormat,
        getLookupValue,
        loadData,
        lookupMap,
    }
}


export type IIxTenantLookupProps = {
    name: string,  // field name in the formik form, would also be used in the lookup context
    readOnly: boolean,
    active?: boolean,
    label?: string,
    onLoadingChanged?: (name: string, isLoading: boolean) => void,
    selectionMode?: 'single' | 'multi' | 'multicsv' | 'range' | 'singlerange',
    getFirstCtxValue?: boolean,
    visible?: boolean,
    openDropdown?: boolean,
    onInfoChange?: any,
    valueExpr?: string,
    updateField?: any,
    objnrField?: string,
}

export const IxTenantLookup = ({
    name,
    readOnly,
    active=true,
    label,
    onLoadingChanged,
    selectionMode='single',
    getFirstCtxValue=false,
    visible=true,
    openDropdown=false,
    onInfoChange,
    valueExpr=_valueExpr,
    updateField,
    objnrField='OBJNR',
}: IIxTenantLookupProps) => {
    const { t } = useTranslation()

    const baseLookup = useRef<any>(null)
    const [field] = useField(name)

    const [firstRender, setFirstRender] = useState(true)
    const lastFormikValue = useRef(null)
    const { paddings } = useSelector((state: RootState) => state.ui)

    const {value: number} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupNumberFormat))
    const {value: separator} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupSeparatorFormat))
    const {value: info} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupInfoFormat))

    const [value, setValue] = useState<any>(null)
    const [callbacks, setCallbacks] = useState<{[k: string]: (v: any, force?: boolean) => void}>({})
    const { data, load, loadItem, loading, reset, setData, dataLoaded, lastParams } = useLookupFetch(fetchConfig)  // eslint-disable-line @typescript-eslint/no-unused-vars

    const { setFieldValue: setLookupFieldValue, getFieldValue: getLookupFieldValue,
        getFieldReadOnly: getLookupFieldReadOnly } = useIxLookupContext()


    const contextFilters = useFiltersList()
    const setContextFilter = contextFilters.setFilter
    const { setFieldValue } = useFormikContext()

    const openLookup = useCallback((searchText: string | undefined, rangeStart?: string) => {
        if (!dataLoaded) { load(contextFilters.state).then(() => baseLookup.current?.open(searchText, rangeStart)) }
        else { baseLookup.current?.open(searchText, rangeStart) }
    }, [dataLoaded, load, contextFilters.state])

    const shouldUpdateConfig: ShouldUpdateArray = useMemo(() => {
        let updateFields: ShouldUpdateArray = []
        if (objnrField)
            updateFields.push({ fieldName: objnrField, valueExpr: 'OBJNR' })
        return updateFields
    }, [
        objnrField,
    ])

    const shouldUpdateContextFiltersCount = useMemo(() => Object.keys(contextFilters.state).reduce((count, key) => {
        // we only count filters that are relevant for shouldUpdateConfig, if all shouldUpdateConfig fileds are loaded and set in contextFilters, the we load and set the value
        if (shouldUpdateConfig.some(m => m.fieldName.toLowerCase() === key.toLowerCase())) {
            return count + 1
        }
        return count
    }, 0), [contextFilters.state, shouldUpdateConfig])


    // formating function to modify displayed value
    const format = useCallback((x: any) => {
        if (x) {
            return `${number.prefix}${zeroPad(x.OBJNR, paddings['OBJNR'])}+${x.NO !== null && x.NO !== undefined ? x.NO : ''}${number.suffix}${separator.value}${info.prefix} ${x.ID !== null && x.ID !== undefined ? x.ID : ''}${info.suffix}`
        } else {
            return field.value ? `${number.prefix}${field.value || ''}${number.suffix}` : ''
        }
    }, [field.value, number, paddings, separator, info])

    const rangeFormat = useCallback((x: any, full: boolean) => {
        if (x) {
            if (full) {
                return `${number.prefix}${zeroPad(x.OBJNR, paddings['OBJNR'])}+${x.NO !== null && x.NO !== undefined ? x.NO.replace('-', '/') : ''}${number.suffix}`
            } else {
                return `${x.NO ? x.NO.replace('-', '/') : ''}`
            }
        } else {
            return `${field.value ? field.value.replace('-', '/') : ''}`
        }
    }, [field.value, number, paddings])

    const handleSelectionChanged = useSelectionChangedCallback({
        value,
        setValue,
        selectionMode,
        displayExpr: rangeFormat
    })

    const handleInputChanged = useInputChangedCallback({
        inputRe,
        getLookupFieldReadOnly,
        loadItem,
        handleSelectionChanged,
        globalFilters: contextFilters.state,
        openLookup,
        selectionMode,
        setValue,
    })

    // call onLoadingChanged callback if available
    useEffect(() => {
        onLoadingChanged && onLoadingChanged(name, loading)
    }, [onLoadingChanged, loading, name])

    useEffect(() => {
        if (value && typeof value !== 'string' && updateField?.name && updateField?.column) {
            Array.isArray(value)
                ? setFieldValue(updateField.name, `${value.map((x: any) => x[updateField.column]).join(',')}`, true)
                : setFieldValue(updateField.name, value[updateField.column], true)
        }

    },[setFieldValue, updateField?.name, updateField?.column, value])

    // callbacks for changes in lookup context
    const onNoChange = useContextSelfCallback({
        valueExpr, contextFilters: contextFilters.state, handleSelectionChanged,
        setData, loadItem, load, castToType, selectionMode
    })
    const onObjnrChange = useContextFilterCallback({
        fieldName: 'objnr', valueExpr: 'OBJNR', setContextFilter: contextFilters.setFilter,
        removeContextFilter: contextFilters.removeFilter, getFirstCtxValue
    })

    // update callbacks for fields we're interested in
    useEffect(() => {
        setCallbacks({
            [name]: onNoChange,
            [objnrField]: onObjnrChange,
        })
    }, [name, onNoChange, onObjnrChange, objnrField])

    // if formik value changes update lookup
    useEffect(() => {
        if (firstRender || !active || _.isEqual(field.value, lastFormikValue.current)) { return }

        if (selectionMode === 'range') {
            lastFormikValue.current = field.value
            setValue(field.value)
        } else if (!field.value || shouldUpdateConfig.length === shouldUpdateContextFiltersCount || valueExpr === 'HDR_ID') {
            lastFormikValue.current = field.value

            if (_.isNil(value) && _.isNil(field.value)) { return }
            else if (_.isNil(field.value)) { handleSelectionChanged(null); return }

            let field_value = field.value;
            if (selectionMode === 'multicsv' && typeof(field.value) === 'string') {
                field_value = field.value.split(',').map((x: string) => ixStringToInt(x))
            }

            if (Array.isArray(field_value)) {
                if (_.isNil(value) || !_.isEqual(value.map((x: any) => x[valueExpr]), field_value)) {
                    if (field_value) {
                        load(contextFilters.state)
                            .then((data: any) => handleSelectionChanged(data.filter((x: any) => field_value.includes(x[valueExpr]))))
                            .catch(() => {})
                    } else {
                        handleSelectionChanged(field_value)
                    }
                }
            } else {
                if (_.isNil(value) || value[valueExpr] !== field_value) {
                    if (field_value) {
                        loadItem(contextFilters.state, { [valueExpr]: field_value })
                            .then((data: any) => handleSelectionChanged(data))
                            .catch(() => {})
                    } else {
                        handleSelectionChanged(field_value)
                    }
                }
            }
        }
    }, [field.value, active, firstRender, contextFilters.state, load,
        loadItem, handleSelectionChanged, selectionMode, value,
        valueExpr, shouldUpdateConfig, shouldUpdateContextFiltersCount])

    useEffect(() => {
        if (firstRender && readOnly && field.value && selectionMode !== 'range' && !_.isEqual(field.value, lastFormikValue.current)) {
            if (value !== null) { return }

            if (!shouldUpdateConfig.length || valueExpr === 'HDR_ID') {
                lastFormikValue.current = field.value
                if (selectionMode === 'single') {
                loadItem(contextFilters.state, { [valueExpr]: field.value })
                        .then(res => handleSelectionChanged(res))
                        .catch(() => {})
                } else {
                    load(contextFilters.state)
                        .then((data: any) => handleSelectionChanged(data.filter((x: any) => field.value.includes(x[valueExpr]))))
                        .catch(() => {})
                }
            }
        }
    }, [loadItem, load, field.value, value, contextFilters.state, readOnly,
        handleSelectionChanged, selectionMode, valueExpr, firstRender,
        shouldUpdateConfig])
 
    useEffect(() => {
        if (!firstRender) { return }
        // get global filters from context
        shouldUpdateConfig.forEach(({ fieldName, valueExpr }: any) => {
            let val = getLookupFieldValue(fieldName)
            if (Array.isArray(val)) {
                if (!getFirstCtxValue) { return }

                val = val[0]
            }
            if (val && typeof(val) === 'object') {
                setContextFilter(fieldName.toLowerCase(), val[valueExpr])
            }
        })

        const val = getLookupFieldValue(name)
        if (selectionMode === 'multi') {
            if (val && Array.isArray(val)) {
                const vIds = val.map((v: any) => v && typeof(v) === 'object' ? v[valueExpr] : null).filter((v: any) => v)
                if (vIds.length === val.length && _.isEqual(vIds, field.value)) {
                    setValue(val)
                    setData(val)
                    lastFormikValue.current = field.value
                }
            }
        } else if (selectionMode === 'multicsv') {
            if (val && Array.isArray(val)) {
                const vIds = val.map((v: any) => v && typeof(v) === 'object' ? v[valueExpr] : null).filter((v: any) => v).join(', ')
                if (_.isEqual(vIds, field.value)) {
                    setValue(val)
                    setData(val)
                    lastFormikValue.current = field.value
                }
            }
        } else {
            if (selectionMode === 'single' && val && typeof(val) === 'object' && field.value === val[valueExpr]) {
                setValue(val)
                setData([val])
                lastFormikValue.current = field.value
            } else if (selectionMode === 'range' && val) {
                setValue(val)
            }
        }

        if (field.value === null && val) {
            setLookupFieldValue(name, null)
        }

        setFirstRender(false)
    }, [firstRender, setContextFilter, getLookupFieldValue, field.value, name, setData,
        setLookupFieldValue, selectionMode, getFirstCtxValue, valueExpr, shouldUpdateConfig])


    const columns = useMemo(() => ([
        {
            dataField: 'HDR_ID',
            dataType: 'number',
            visible: false,
            caption: t('global:field.HDR_ID'),
        },
        {
            dataField: 'OBJNR',
            dataType: 'number',
            visible: true,
            caption: t('object:field.OBJNR'),
        },
        {
            dataField: 'NO',
            dataType: 'string',
            visible: true,
            caption: t('tenant:field.NO'),
        },
        {
            dataField: 'ID',
            dataType: 'string',
            visible: true,
            caption: t('tenant:field.ID'),
        },
    ]), [t])

    const customizeColumns = useCallback((columns: any[]) => {
        columns.forEach((col: any) => {
            if (col.dataField === 'OBJNR') {
                col.format = (x: any) => zeroPad(x, paddings['OBJNR'])
            }
        })
    }, [paddings])



    return (
        <BaseLookup
            ref={baseLookup}
            name={name}
            label={label || t('tenant:label.tenantLookup')}
            opts={data}
            readOnly={readOnly}
            valueExpr={valueExpr}
            keyExpr='HDR_ID'
            displayExpr={format}
            inputExpr={inputFormat}
            loading={loading}
            selectionMode={selectionMode}
            visible={visible}
            customizeColumns={customizeColumns}

            onInputChanged={handleInputChanged}
            onSelectionChanged={handleSelectionChanged}

            value={value}
            callbacks={callbacks}

            contextFilters={contextFilters}
            loadFn={load}
            resetFn={reset}

            columns={columns}

            openDropdown={openDropdown}
            onInfoChange={onInfoChange}

            shouldUpdate={shouldUpdateConfig}
            getFirstCtxValue={getFirstCtxValue}

            dataLoaded={dataLoaded}


        />
    )
}
